import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import style from './Cpu.style';

const CpuSvg = ({ className, gateStatus, ...rest }) => {
    const CPUSVG_ANIMATION_CLASSES = {
        drawCpuPins: 'cpu-core-svg_draw-cpu-pins',
        drawCpuPinsShadow: 'cpu-core-svg_draw-cpu-pins-shadow',
        cpuShine: 'cpu-core-shine'
    };
    const [drawCpuPins, setDrawCpuPins] = useState('');
    const [drawCpuPinsShadow, setDrawCpuPinsShadow] = useState('');
    const [cpuShine, setCpuShine] = useState('');

    useEffect(
        () => {
            if (gateStatus === 'open') {
                setDrawCpuPins(CPUSVG_ANIMATION_CLASSES.drawCpuPins);
                setDrawCpuPinsShadow(CPUSVG_ANIMATION_CLASSES.drawCpuPinsShadow);
                setTimeout(() => {
                    setCpuShine(CPUSVG_ANIMATION_CLASSES.cpuShine);
                }, 6000);
            }
        },
        [gateStatus]
    );

    return (
        <div className={className} {...rest}>
            <div className="cpu">
                <div id="cpu-gate-left-id" className={`cpu-gate-left cpu-gate_${gateStatus}`} />
                <div className="cpu-core">
                    <div
                        id="cpu-core-container-id"
                        className={`cpu-core-shine-container ${cpuShine}`}
                    />
                </div>
                <svg className="cpu-core-svg" viewBox="0 0 132 132">
                    <g>
                        <g
                            className="cpu-core-svg-shadow"
                            transform="translate(29.000000, 29.000000)"
                            fillRule="nonzero"
                        >
                            <rect className="cpu-core-svg-bg-shadow" x="18" y="18" />
                            <path
                                className="cpu-core-svg-AI-shadow"
                                d="M34.6953125,51 L35.5625,47.7890625 L41.1289062,47.7890625 L41.9726562,51 L47.0351562,51 L41.375,33.796875 L35.1992188,33.796875 L29.609375,51 L34.6953125,51 Z M40.1679688,43.9921875 L36.5234375,43.9921875 C37.234375,41.3046875 37.6933594,39.5039062 37.9003906,38.5898438 C38.1074219,37.6757812 38.2460938,37.0195312 38.3164062,36.6210938 C38.3945312,37.0507812 38.5566406,37.7617188 38.8027344,38.7539062 C39.0488281,39.7460938 39.2578125,40.5546875 39.4296875,41.1796875 L39.4296875,41.1796875 L40.1679688,43.9921875 Z M53.5390625,51 L53.5390625,33.8671875 L48.8867188,33.8671875 L48.8867188,51 L53.5390625,51 Z"
                            />
                            <path
                                id="cpu-core-border-shadow-id"
                                className={`cpu-core-svg-border-shadow ${drawCpuPinsShadow}`}
                                d="M30,0 L30,16 L34,16 L34,0 L40,0 L40,16 L44,16 L44,0 L50,0 L50,16 L54,16 L54,0 L60,0 L60,16 L68,16 L68,24 L84,24 L84,30 L68,30 L68,34 L84,34 L84,40 L68,40 L68,44 L84,44 L84,50 L68,50 L68,54 L84,54 L84,60 L68,60 L68,68 L60,68 L60,84 L54,84 L54,68 L50,68 L50,84 L44,84 L44,68 L40,68 L40,84 L34,84 L34,68 L30,68 L30,84 L24,84 L24,68 L16,68 L16,60 L0,60 L0,54 L16,54 L16,50 L0,50 L0,44 L16,44 L16,40 L0,40 L0,34 L16,34 L16,30 L0,30 L0,24 L16,24 L16,16 L24,16 L24,0 L30,0 Z M66,18 L18,18 L18,66 L66,66 L66,18 Z"
                            />
                        </g>
                        <g transform="translate(23.000000, 23.000000)" fillRule="nonzero">
                            <rect className="cpu-core-svg-bg" fill="#504C43" x="17" y="17" />
                            <path
                                className="cpu-core-svg-AI"
                                d="M35.6953125,52 L36.5625,48.7890625 L42.1289062,48.7890625 L42.9726562,52 L48.0351562,52 L42.375,34.796875 L36.1992188,34.796875 L30.609375,52 L35.6953125,52 Z M41.1679688,44.9921875 L37.5234375,44.9921875 C38.234375,42.3046875 38.6933594,40.5039062 38.9003906,39.5898438 C39.1074219,38.6757812 39.2460938,38.0195312 39.3164062,37.6210938 C39.3945312,38.0507812 39.5566406,38.7617188 39.8027344,39.7539062 C40.0488281,40.7460938 40.2578125,41.5546875 40.4296875,42.1796875 L40.4296875,42.1796875 L41.1679688,44.9921875 Z M54.5390625,52 L54.5390625,34.8671875 L49.8867188,34.8671875 L49.8867188,52 L54.5390625,52 Z"
                            />
                            <path
                                id="cpu-core-border-id"
                                className={`cpu-core-svg-border ${drawCpuPins}`}
                                d="M55,0 L61,0 L61,17 L69,17 L69,25 L85,25 L85,31 L69,31 L69,35 L85,35 L85,41 L69,41 L69,45 L85,45 L85,51 L69,51 L69,55 L85,55 L85,61 L69,61 L69,69 L61,69 L61,85 L55,85 L55,69 L51,69 L51,85 L45,85 L45,69 L41,69 L41,85 L35,85 L35,69 L31,69 L31,85 L25,85 L25,69 L17,69 L17,61 L0,61 L0,55 L17,55 L17,51 L0,51 L0,45 L17,45 L17,41 L0,41 L0,35 L17,35 L17,31 L0,31 L0,25 L17,25 L17,17 L55,17 L55,0 Z M67,19 L19,19 L19,67 L67,67 L67,19 Z M51,0 L51,17 L45,17 L45,0 L51,0 Z M41,0 L41,17 L35,17 L35,0 L41,0 Z M31,0 L31,17 L25,17 L25,0 L31,0 Z"
                            />
                        </g>
                    </g>
                </svg>
                <div id="cpu-gate-right-id" className={`cpu-gate-right cpu-gate_${gateStatus}`} />
            </div>
        </div>
    );
};

export const Cpu = styled(CpuSvg)`
    ${style};
`;
